import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {TableColumn, TableColumnType} from '../../../interfaces/table.interface';
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-table-download',
    templateUrl: './table-download.component.html',
    styleUrls: ['./table-download.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class TableDownloadComponent implements OnInit {

  tableColumnType = TableColumnType;

  today = new Date();

  @Input() tableData$: Observable<any[]>;
  @Input() AllTableColumn: TableColumn[];
  @Input() selectedTableColumn: TableColumn[];
  @Input() title: string;
  @Input() subTitle: string;

  constructor() {
  }

  ngOnInit(): void {

    if (this.selectedTableColumn?.length === 0 || this.selectedTableColumn === undefined){
      this.selectedTableColumn = this.AllTableColumn;
    }
  }

  getObjectValue(tableData: any, keyword: string) {
    const keyArray = keyword.split('.');
    let value = tableData;

    if (keyArray?.length > 0) {
      keyArray?.forEach( (key) => {
        if (value != null){
          if (Object?.keys(value)?.findIndex( k => k === key) > -1){
            value = value[key];
          } else {
            return null;
          }
        }
      });
    }
    return value;
  }


  tableColumnChange(data: TableColumn[]) {
    this.selectedTableColumn = data;
  }

  downloadExcel() {
    /* table id is passed over here */
    const element = document.getElementById('printSection');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, this.title);

    /* save to file */
    XLSX.writeFile(wb, this.title + '.xlsx');

    // this.excelService.download1( this.title, this.dataTable.nativeElement);
  }
}
